(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-brand-quotes"] && !window.DesignMode) return;
  try {
    
   let page = 1;
   const nextBtn = document.getElementById("next-btn");
   const prevBtn = document.getElementById("prev-btn");
   const textCont = document.querySelector(".cbq-text-cont");
   const textItems = document.querySelectorAll(".cbq-text");
   const brandLogos = document.querySelectorAll(".cbq-logo")

  function grayScaleImages() {
    document.querySelectorAll('.cbq-logo-cont .cbq-logo-img').forEach(function(item) {
      item.style.filter = 'blur(1px)';
    })
  }

  function scrollToPage(pageNumber) {
     if (pageNumber === 1) {
       // Scroll to the very start of the container
       textCont.scrollTo({
         left: 0,
         behavior: 'smooth'
       });
       grayScaleImages()
       document.getElementById(`cbq-logo-img-${pageNumber}`).style.filter = 'blur(0px)';
     } else {
       // Scroll to the target element
       const targetElement = textItems[pageNumber - 1];
       if (targetElement) {
         textCont.scrollTo({
           left: targetElement.offsetLeft - 120,
           behavior: 'smooth'
         });
         console.log(targetElement.offsetLeft)
         grayScaleImages()
         document.getElementById(`cbq-logo-img-${pageNumber}`).style.filter = 'blur(0px)';
       }
     }
   }

    brandLogos.forEach(function(logo) {
      logo.addEventListener('click', function() {
        var logoPage = this.getAttribute('page');
        page = logoPage;
        scrollToPage(logoPage);
      });
    });

   nextBtn.addEventListener('click', function() {
     if (page < textItems.length) {
       page += 1;
       scrollToPage(page);
     }
   });

   prevBtn.addEventListener('click', function() {
     if (page > 1) {
       page -= 1;
       scrollToPage(page);
     }
   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collections-header"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    let arrowDownIcon = document.querySelectorAll(".arrow-down-icon");

    if (arrowDownIcon) {
      arrowDownIcon.forEach(el => {
        const parentLi = el.closest('li');
        parentLi.addEventListener('click', () => {
          const childDownIcon = parentLi.querySelector('.arrow-down-icon');
          const childUpIcon = parentLi.querySelector('.arrow-up-icon');
          childDownIcon.style.display == 'none' ? childDownIcon.style.display = '' : childDownIcon.style.display = 'none'
          childUpIcon.style.display == 'none' ? childUpIcon.style.display = '' : childUpIcon.style.display = 'none'
        })
      })
    }

    let collectionBtn = document.getElementById('cc-header-menu-panel-collapsible-btn');
    let collectionDropdown = document.getElementById('cc-header-menu-panel-collapsible');
    let collectionBtnB = document.getElementById('cc-header-menu-panel-collapsible-btn-b');
    let collectionDropdownB = document.getElementById('cc-header-menu-panel-collapsible-b');
    let collectionBtnC = document.getElementById('cc-header-menu-panel-collapsible-btn-c');
    let collectionDropdownC = document.getElementById('cc-header-menu-panel-collapsible-c');

    const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');
    mobileNavLinks.forEach(el => {
      el.addEventListener('click', (event) => {
        const childLink = el.querySelector('a').getAttribute('href');
        window.location.href = childLink;
      });
    });

    collectionBtn.addEventListener('click', function() {
      if (collectionDropdown.style.display == "none") {
        collectionDropdown.style.display = "flex"
      } else {
        collectionDropdown.style.display = "none"
      }
    })

    collectionBtnB.addEventListener('click', function() {
      if (collectionDropdownB.style.display == "none") {
        collectionDropdownB.style.display = "flex"
      } else {
        collectionDropdownB.style.display = "none"
      }
    })

    collectionBtnC.addEventListener('click', function() {
      if (collectionDropdownC.style.display == "none") {
        collectionDropdownC.style.display = "flex"
      } else {
        collectionDropdownC.style.display = "none"
      }
    })

    var navBarBtn = document.getElementById('menu-btn')
    var narBarCloseBtn = document.getElementById('close-sidebar-btn')
    var navBar = document.getElementById('cc-header-menu-panel')
    navBarBtn.addEventListener('click', function() {
      navBar.style.display = 'flex'; // Ensure the navbar is visible
      navBar.style.transform = 'translateX(0)'; // Slide it into view
    });
    narBarCloseBtn.addEventListener('click', function() {
      navBar.style.display = 'none'
    })

    var btn1 = document.getElementById('pl-1');
    var cont1 = document.getElementById('pl-cont-1');
    // var btn2 = document.getElementById('pl-2');
    // var cont2 = document.getElementById('pl-cont-2');
    // var btn3 = document.getElementById('pl-3');
    // var cont3 = document.getElementById('pl-cont-3');
    var btn4 = document.getElementById('pl-4');
    var cont4 = document.getElementById('pl-cont-4');
    var btn5 = document.getElementById('pl-5');
    var cont5 = document.getElementById('pl-cont-5');

    function hideAll(current) {
      current === 1 ? '' : cont1.style.display = 'none'
      // current === 2 ? '' : cont2.style.display = 'none'
      // current === 3 ? '' : cont3.style.display = 'none'
      current === 4 ? '' : cont4.style.display = 'none'
      current === 5 ? '' : cont5.style.display = 'none'
      btn1.style.fontWeight = "400";
      // btn2.style.fontWeight = "400";
      // btn3.style.fontWeight = "400";
      btn4.style.fontWeight = "400";
      btn5.style.fontWeight = "400";
    }

    btn1.addEventListener('click', function() {
      hideAll(1)
      if (cont1.style.display === 'none' || cont1.style.display === '') {
        cont1.style.display = 'flex';
        btn1.style.fontWeight = "bold";
      } else {
        cont1.style.display = 'none';
        btn1.style.fontWeight = "400";
      }
    });
    // btn2.addEventListener('click', function() {
    //   hideAll(2)
    //   if (cont2.style.display === 'none' || cont2.style.display === '') {
    //     cont2.style.display = 'block';
    //     btn2.style.fontWeight = "bold";
    //   } else {
    //     cont2.style.display = 'none';
    //     btn2.style.fontWeight = "400";
    //   }
    // });
    // btn3.addEventListener('click', function() {
    //   hideAll(3)
    //   if (cont3.style.display === 'none' || cont3.style.display === '') {
    //     cont3.style.display = 'block';
    //     btn3.style.fontWeight = "bold";
    //   } else {
    //     cont3.style.display = 'none';
    //     btn3.style.fontWeight = "400";
    //   }
    // });
    btn4.addEventListener('click', function() {
      hideAll(4)
      if (cont4.style.display === 'none' || cont4.style.display === '') {
        cont4.style.display = 'block';
        btn4.style.fontWeight = "bold";
      } else {
        cont4.style.display = 'none';
        btn4.style.fontWeight = "400";
      }
    });
    btn5.addEventListener('click', function() {
      hideAll(5)
      if (cont5.style.display === 'none' || cont5.style.display === '') {
        cont5.style.display = 'block';
        btn5.style.fontWeight = "bold";
      } else {
        cont5.style.display = 'none';
        btn5.style.fontWeight = "400";
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-landing-page"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Select the header container
    const headerContainer = document.getElementsByClassName("header-wrapper")[0];

    // Select all the divs with class 'shopify-section-group-header-group'
    const headerGroups = document.querySelectorAll('.shopify-section-group-header-group');

    // Calculate the total height of all these divs
    let totalHeaderHeight = 0;
    headerGroups.forEach(group => {
      totalHeaderHeight += group.offsetHeight;
    });

    // Set the total header height as a CSS variable
    document.documentElement.style.setProperty('--header-height', `${totalHeaderHeight}px`);
        function daysUntilChristmas() {
        const today = new Date();
        const year = today.getFullYear();
        const christmas = new Date(year, 11, 25); // December 25th of the current year
        
        // If Christmas has already passed this year, set it for next year
        if (today > christmas) {
            christmas.setFullYear(year + 1);
        }

        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const daysLeft = Math.round((christmas - today) / oneDay);

        return daysLeft;
    }

    // Set the content of the h1 element
    document.getElementById("christmas-countdown").textContent = daysUntilChristmas();

    document.getElementById("promotion-close").addEventListener('click', function() {
      document.getElementsByClassName("clp-promo-highlight")[0].style.display = "none"
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-your-ideal-tree"] && !window.DesignMode) return;
  try {
    

  let result = ""

  let header = document.getElementsByClassName('itqc-header')[0]
  let body = document.getElementsByClassName('itqc-body')[0]

  let question = document.getElementById('main-question')
  let subHeading = document.getElementById('main-sub-heading')

  function reset() {
    body.style.display = 'none'
    header.style.display = 'flex'
    document.getElementById("reccommendations-cont").style.display = 'none'
  }

  function attachListeners() {
    const questionAnswers = document.getElementsByClassName("question-option")
    Array.from(questionAnswers).forEach(function(option) {
        const questionIndex = option.getAttribute('result')
        switch(questionIndex.charAt(0)) {
          case "1":
            switch(questionIndex) {
              case "1a":
              case "1d":
                option.addEventListener('click', function() {
                  result += option.getAttribute("result");
                  step.step += 1;         
                })
                break;
              case "1b":
              case "1c":
                option.addEventListener('click', function() {
                  result += option.getAttribute("result");
                  step.step = 4;
                })
                break;
            }
            break;
          case "2":
            option.addEventListener('click', function() {
              result += option.getAttribute("result");
              step.step = 3;
            })
            break;
          case "3":
            option.addEventListener('click', function() {
              result += option.getAttribute("result");
              step.step = 5;
            })
            break;
          case "4":
            switch (questionIndex) {
              case "4a":
                option.addEventListener('click', function() {
                  result += option.getAttribute("result");
                  step.step = 2;
                })
                break;
              case "4b":
                option.addEventListener('click', function() {
                  result += option.getAttribute("result");
                  step.step = 2;
                })
                break;
            }
            break;
          case "5":
            console.log("Redirect")
            break;
          default:
            console.log("Something went wrong")
            break;
        }
    });
  }

  function generateOptions(options, stepp, secondAnswer, firstAnswer) {
    const optionsContainer = document.querySelector('.q-options-container');
    optionsContainer.innerHTML = ''; // Clear existing options

    options.forEach((option, index) => {
        const optionDiv = document.createElement('div');
        optionDiv.classList.add('q-option');
        optionDiv.classList.add(`question-option`);
        const resultValue = `${stepp}${String.fromCharCode(97 + index)}`; // Generates '1a', '2b', etc.
        optionDiv.setAttribute('result', resultValue);

        const title = document.createElement('h3');
        title.innerText = option[0]; // The option title
        title.classList.add('option-content')

        const description = document.createElement('p');
        description.innerText = option[1]; // The option description
        description.classList.add('option-content')
 
        optionDiv.appendChild(title);
        optionDiv.appendChild(description);
        if (option[2]) {
          const reccomendation = document.createElement('p');
          reccomendation.innerText = `Reccomended for ${option[2]}`
          reccomendation.classList.add('option-recommendation')
          optionDiv.appendChild(reccomendation);
        }
        if (stepp == 3 && secondAnswer[0] == 4 && index == 0) {
        }else if(stepp == 3 && (index == 0 || index == 1) && firstAnswer == "1a") {
        }else if (stepp == 3 && (firstAnswer == "1b" || firstAnswer == "1c")) {
          if (secondAnswer == '4a') {
            if (index == 2 || index == 3) {
              optionsContainer.appendChild(optionDiv);
            }
          } else {
            if (index == 1 || index == 2) {
              optionsContainer.appendChild(optionDiv);
            } 
          }
        } else {
          optionsContainer.appendChild(optionDiv);
        }
    });

    attachListeners()
    console.log(result);
  }
  
  function questionOne() {
    header.style.display = 'none'
    body.style.display = 'flex'
    question.innerText = "What’s your favorite tree style?"
    subHeading.innerText = "Pick the one that feels like home."

    const options = [
      ["Flocked", "I love a snow-dusted look!"],
      ["Pre-Lit", "Ready to shine without the hassle."],
      ["Classic Green", "Can’t beat the traditional evergreen."],
      ["White", "A winter wonderland in my living room!"]
    ]

    generateOptions(options, step.step)
  }

  function questionTwo() {
    header.style.display = 'none'
    body.style.display = 'flex'
    question.innerText = "Where will your tree go?"
    subHeading.innerText = "Help us find the right fit for your space!"

    const options = [
      ["Living room", "The heart of the home."],
      ["Entryway", "A festive welcome."],
      ["Office/Study", "A little holiday cheer at work."],
      ["Outdoors", "Let the whole neighborhood see it!"],
      ["Not Sure Yet", "I’m still deciding where to put it!"]
    ]

    generateOptions(options, step.step)
  }

  function questionThree() {
    header.style.display = 'none'
    body.style.display = 'flex'
    question.innerText = "Which Christmas tree height do you prefer?"
    subHeading.innerText = "Based on our recommendations, what height works best for your space?"

    const previousAnswer = result.slice(-2);
    const firstAnswer = result.slice(0, 2);
    const secondAnswer = result.slice(2, 4);
    
    let options = []
    
    switch(previousAnswer) {
      case "2a":
        options = [
          ["Under 5 feet", "Small but mighty!", "Living Room"],
          ["5-6 feet", "Just right for most homes.", "Living Room"],
          ["7-8 feet", "Grand, but not too big.", "Living Room"],
          ["Over 8 feet", "The bigger, the better!", "Living Room"]
        ]
        break;
      case "2b":
        options = [
          ["Under 5 feet", "Small but mighty!"],
          ["5-6 feet", "Just right for most homes.", "Entryways"],
          ["7-8 feet", "Grand, but not too big.", "Entryways"],
          ["Over 8 feet", "The bigger, the better!", "Entryways"]
        ]
        break;
      case "2c":
        options = [
          ["Under 5 feet", "Small but mighty!", "Office/Study"],
          ["5-6 feet", "Just right for most homes.", "Office/Study"],
          ["7-8 feet", "Grand, but not too big."],
          ["Over 8 feet", "The bigger, the better!"]
        ]
        break;
      case "2d":
        options = [
          ["Under 5 feet", "Small but mighty!", "Outdoors"],
          ["5-6 feet", "Just right for most homes.", "Outdoors"],
          ["7-8 feet", "Grand, but not too big."],
          ["Over 8 feet", "The bigger, the better!"]
        ]
        break;
      default:
        options = [
          ["Under 5 feet", "Small but mighty!"],
          ["5-6 feet", "Just right for most homes."],
          ["7-8 feet", "Grand, but not too big."],
          ["Over 8 feet", "The bigger, the better!"]
        ]
        break;
    }

    generateOptions(options, step.step, secondAnswer, firstAnswer)
  }

  function questionFour() {
    header.style.display = 'none'
    body.style.display = 'flex'
    question.innerText = "What type of tree material do you prefer?"
    subHeading.innerText = "Choose the material that makes your tree look and feel just right."

    const options = [
      ["PVC", "Affordable, durable, and easy to set up for hassle-free holiday cheer."],
      ["PE/PVC Mixed", "Realistic branches with a lush, full look—get the best of both worlds!"]
    ]

    generateOptions(options, step.step)
  }

  function getFirstWord(str) {
    return str.split(' ')[0];
  }

  function renderReccommendations(product) {
    const reccommendationsCont = document.getElementById('reccommendations')
    
    const container = document.createElement('a')
    container.classList.add('product-reccommendation-item')
    container.setAttribute('href', `https://merrybrightshop.com/products/${product.handle}`)
    const image = document.createElement('img')
    image.setAttribute('src', product.images[0].src)
    image.classList.add('product-reccommendation-image')
    const title = document.createElement('h2')
    title.classList.add('h3')
    title.innerText = `${product.title} Christmas Tree`

    container.appendChild(image)
    container.appendChild(title)
    reccommendationsCont.appendChild(container)
  }

  function displayResults() {
    const firstCode = result.slice(0, 2);
    const secondCode = result.slice(2, 4);
    const thirdCode = result.slice(4, 6);
    const fourthCode = result.slice(6, 8);

    console.log(firstCode)
    console.log(secondCode)
    console.log(thirdCode)
    console.log(fourthCode)

    const collection = (firstCode == '1a' ? 'flocked-christmas-trees' : ( firstCode == '1b' ? 'pre-lit-christmas-trees' : ( firstCode =='1c' ? 'unlit-christmas-trees' : 'white-christmas-trees' )))
    let minHeight = 0
    let maxHeight = 0
    let material = "pvc"

    if (firstCode == '1b' || firstCode == '1c') {
      if (secondCode == '4a') {
        material = "pvc"
      } else {
        material = "pe/pvc"
      }
    }

    if (firstCode == '1a' || firstCode == '1d') {
      switch (thirdCode) {
        case '3a':
          minHeight = 1
          maxHeight = 4
          break;
        case '3b':
          minHeight = 5
          maxHeight = 6
          break;
        case '3c':
          minHeight = 7
          maxHeight = 8
          break;
        case '3d':
          minHeight = 9
          maxHeight = 9
          break;
      }
    } else {
      switch (fourthCode) {
        case '3a':
          minHeight = 1
          maxHeight = 4
          break;
        case '3b':
          minHeight = 5
          maxHeight = 6
          break;
        case '3c':
          minHeight = 7
          maxHeight = 8
          break;
        case '3d':
          minHeight = 9
          maxHeight = 9
          break;
      }
    }    

    const recCont = document.getElementById("reccommendations-cont")
    recCont.style.display = "";

    fetch(`/collections/${collection}/products.json`)
    .then(response => response.json())
    .then(data => {
      const products = data.products;
      console.log(products)
      products.forEach(function(pr) {
        if (getFirstWord(pr.title) >= minHeight && getFirstWord(pr.title) <= maxHeight) {
          if (material == 'pvc') {
            if (pr.title.includes('Mixed')) {
            } else {
              renderReccommendations(pr)
            }
          } else {
            if (pr.title.includes('Mixed')) {
              renderReccommendations(pr)
            }
          }
        }
      })
      body.style.display = "none"
    })
    .catch(error => {
      console.error('Error fetching the collection:', error);
    });
  }
  
  const step = {
    _step: 0,
    get step() {
      return this._step;
    },
    set step(value) {
      this._step = value;
      this.notifyListeners(value);
    },
    listeners: [],
    addListener(callback) {
      this.listeners.push(callback);
    },
    notifyListeners(value) {
      this.listeners.forEach(callback => callback(value));
    }
  }

  step.addListener(newValue => {
    if (newValue === 1) {
      questionOne()
    } else if (newValue === 2) {
      questionTwo()
    } else if (newValue === 3) {
      questionThree()
    } else if (newValue === 4) {
      questionFour()
    } else if (newValue === 5) {
      displayResults()
      // window.location.href = `https://merrybrightshop.com/pages/your-ideal-tree?result=${result}`
    } else {
      reset()
    }
  })

  document.getElementById("start-btn").addEventListener('click', function() {
    step.step = 1
  })
  document.getElementById("reset-btn").addEventListener('click', function() {
    step.step = 0
    result = ""
  })
  document.getElementById("rec-reset-btn").addEventListener('click', function() {
    window.location.reload()
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ideal-tree-results"] && !window.DesignMode) return;
  try {
    
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
  const result = getQueryParam('result');
  const firstCode = result.slice(0, 2);
  const secondCode = result.slice(2, 4);
  const thirdCode = result.slice(4, 6);
  const fourthCode = result.slice(6, 8);

  const collection = (firstCode == '1a' ? 'flocked-christmas-trees' : ( firstCode == '1b' ? 'pre-lit-christmas-trees' : ( firstCode =='1c' ? 'unlit-christmas-trees' : 'white-christmas-trees' )))
  let minHeight = 0
  let maxHeight = 0
  let material = "pvc"

  if (firstCode == '1b' || firstCode == '1c') {
    if (secondCode == '4a') {
      material = "pvc"
    } else {
      material = "pe/pvc"
    }
  }

  if (firstCode == '1a' || firstCode == '1d') {
    switch (thirdCode) {
      case '3a':
        minHeight = 1
        maxHeight = 4
        break;
      case '3b':
        minHeight = 5
        maxHeight = 6
        break;
      case '3c':
        minHeight = 7
        maxHeight = 8
        break;
      case '3d':
        minHeight = 9
        maxHeight = 9
        break;
    }
  } else {
    switch (fourthCode) {
      case '3a':
        minHeight = 1
        maxHeight = 4
        break;
      case '3b':
        minHeight = 5
        maxHeight = 6
        break;
      case '3c':
        minHeight = 7
        maxHeight = 8
        break;
      case '3d':
        minHeight = 9
        maxHeight = 9
        break;
    }
  }

  function getFirstWord(str) {
    return str.split(' ')[0];
  }

  const reccommendationsCont = document.getElementById('reccommendations')

  function renderReccommendations(product) {
    const container = document.createElement('a')
    container.classList.add('product-reccommendation-item')
    container.setAttribute('href', `https://merrybrightshop.com/products/${product.handle}`)
    const image = document.createElement('img')
    image.setAttribute('src', product.images[0].src)
    image.classList.add('product-reccommendation-image')
    const title = document.createElement('h2')
    title.classList.add('h3')
    title.innerText = `${product.title} Christmas Tree`

    container.appendChild(image)
    container.appendChild(title)
    reccommendationsCont.appendChild(container)
  }

  function attachListeners() {
    const recs = document.querySelectorAll('.product-reccommendation-image')
    recs.forEach(function(rec) {
      rec.addEventListener("mouseenter", function() {
        rec.style.filter = 'grayscale(0%)'
      })
      rec.addEventListener("mouseleave", function() {
        rec.style.filter = 'grayscale(50%)'
      })
    })
  }
    
  fetch(`/collections/${collection}/products.json`)
  .then(response => response.json())
  .then(data => {
    const products = data.products;
    console.log(products)
    products.forEach(function(pr) {
      if (getFirstWord(pr.title) >= minHeight && getFirstWord(pr.title) <= maxHeight) {
        if (material == 'pvc') {
          if (pr.title.includes('Mixed')) {
          } else {
            renderReccommendations(pr)
          }
        } else {
          if (pr.title.includes('Mixed')) {
            renderReccommendations(pr)
          }
        }
      }
    })
    attachListeners()
  })
  .catch(error => {
    console.error('Error fetching the collection:', error);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  const tocHeader = document.getElementsByClassName("toc-header")[0];
  const tocBody = document.getElementsByClassName("toc-body")[0];
  const tocShowBtn = document.getElementById("toc-show-btn");
  const tocHideBtn = document.getElementById("toc-hide-btn");
  tocHeader.addEventListener('click', () => {
    tocBody.style.display == 'none' ? tocBody.style.display = 'block' : tocBody.style.display = 'none';
    if (tocHideBtn.style.display == 'none') {
      tocShowBtn.style.display = 'none'
      tocHideBtn.style.display = 'block'
    } else {
      tocShowBtn.style.display = 'block'
      tocHideBtn.style.display = 'none'
    }
  })
  window.addEventListener("scroll", () => {
    const scrollToTopBtn = document.getElementById('scroll-to-top-btn')
    if (window.scrollY > 100) {
      scrollToTopBtn.classList.add("visible");
    } else {
      scrollToTopBtn.classList.remove("visible");
    }
    scrollToTopBtn.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", 
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
